import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getAllInvestmentsProducts = async (searchBy) => {
  const { data } = await getDataWithDotNet(
    `${ajaxEndpoints.FUNDER_INVESTMENT_PRODUCT}?status=${searchBy}`
  );
  return data;
};

export default function useAllInvestmentsProducts(searchBy) {
  return useQuery(
    [searchBy, "getAllInvestmentsProducts"],
    getAllInvestmentsProducts,
    {
      refetchOnWindowFocus: false,
    }
  );
}
